/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseSearchInfo} from '../models/LicenseSearchInfo';
import type {LicenseShortInfo} from '../models/LicenseShortInfo';

export interface GetAccountsActiveLicenses$Request {
    requestBody: Array<number>;
}

export interface GetAccountsActiveLicenses$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsActiveLicensesRequest = createAction<PayloadData<void, GetAccountsActiveLicenses$Request>>('ACCOUNT_ACTIVE_LICENSE__GET_ACCOUNTS_ACTIVE_LICENSES__REQUEST');
export const getAccountsActiveLicensesSuccess = createAction<PayloadData<{ [key: string]: LicenseSearchInfo; }, GetAccountsActiveLicenses$Request>>('ACCOUNT_ACTIVE_LICENSE__GET_ACCOUNTS_ACTIVE_LICENSES__SUCCESS');
export const getAccountsActiveLicensesFailure = createAction<PayloadData<Error, GetAccountsActiveLicenses$Request, true>>('ACCOUNT_ACTIVE_LICENSE__GET_ACCOUNTS_ACTIVE_LICENSES__FAILURE');

export const getAccountsActiveLicensesActions = [
    getAccountsActiveLicensesRequest,
    getAccountsActiveLicensesSuccess,
    getAccountsActiveLicensesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsActiveLicenses = (meta: GetAccountsActiveLicenses$Request, config?: GetAccountsActiveLicenses$Config) => {
    return {
        CALL_API: {
            types: getAccountsActiveLicensesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/search/licenses`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetActiveAccountProfileLicense$Request {
    accountId: number;
}

export interface GetActiveAccountProfileLicense$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getActiveAccountProfileLicenseRequest = createAction<PayloadData<void, GetActiveAccountProfileLicense$Request>>('ACCOUNT_ACTIVE_LICENSE__GET_ACTIVE_ACCOUNT_PROFILE_LICENSE__REQUEST');
export const getActiveAccountProfileLicenseSuccess = createAction<PayloadData<LicenseShortInfo, GetActiveAccountProfileLicense$Request>>('ACCOUNT_ACTIVE_LICENSE__GET_ACTIVE_ACCOUNT_PROFILE_LICENSE__SUCCESS');
export const getActiveAccountProfileLicenseFailure = createAction<PayloadData<Error, GetActiveAccountProfileLicense$Request, true>>('ACCOUNT_ACTIVE_LICENSE__GET_ACTIVE_ACCOUNT_PROFILE_LICENSE__FAILURE');

export const getActiveAccountProfileLicenseActions = [
    getActiveAccountProfileLicenseRequest,
    getActiveAccountProfileLicenseSuccess,
    getActiveAccountProfileLicenseFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getActiveAccountProfileLicense = (meta: GetActiveAccountProfileLicense$Request, config?: GetActiveAccountProfileLicense$Config) => {
    return {
        CALL_API: {
            types: getActiveAccountProfileLicenseActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/profile/active-license`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

